// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import Router from 'next/router';
import SCInput from '@/components/sc-controls/form-controls/sc-input';
import SCPasswordInput from '@/components/sc-controls/form-controls/sc-password-input';
import { colors, layout} from '@/theme';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import ConfirmAccess from '@/components/modals/auth/confirm-access';
import SubscriptionContext from '@/utils/subscription-context';
import BillingService from '@/services/billing-service';
import Constants from '@/utils/constants';
import SCComboBox from "@/components/sc-controls/form-controls/sc-combobox";
import employeeService from '@/services/employee/employee-service';
import { Flex, Switch, Text } from '@mantine/core';
import { Button as MantineButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import Storage from '@/utils/storage';
import { createFileRoute } from '@tanstack/react-router'



function CreateEmployee() {

  const subscriptionContext = useContext(SubscriptionContext);

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const [submitting, setSubmitting] = useState(false);
  const toast = useContext(ToastContext);

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());
  const [confirmEmployeeAccessOptions, setConfirmEmployeeAccessOptions] = useState({
    display: false,
    onConfirm: () => { },
  });

  const [selectedPermissions, setSelectedPermissions] = useState<any[]>([]);
  const [primaryRoles, setPrimaryRoles] = useState<any[]>([]);

  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (!firstLoad && selectedPermissions) {
      setFormIsDirty(true);
    }
    setFirstLoad(false);
  }, [selectedPermissions]);

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const [customerStatus, setCustomerStatus] = useState<any>(null);

  const getSubcriptionInfo = async () => {
    const [subscriptionInfo, message] = await BillingService.getSubcriptionInfo(subscriptionContext);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
      setCustomerStatus(subscriptionInfo.CustomerStatus);
    }
  };

  const getPrimaryRoles = async () => {
    setPrimaryRoles(await employeeService.getPrimaryRoles());
  };

  useEffect(() => {
    getSubcriptionInfo();
    getPrimaryRoles();
  }, []);

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, submitEmployee);

  const [inputs, setInputs] = useState({
    FirstName: "",
    LastName: "",
    EmailAddress: "",
    MobileNumber: "",
    canLogin: true, //subscriptionContext && subscriptionContext.subscriptionInfo && subscriptionContext.subscriptionInfo.AccessStatus === Enums.AccessStatus.Trial ? true : false,
    password: "",
    confirmPassword: "",
    IsTechnician: false,
    IsSalesRepresentative: false,
    SendEmail: true,
    SendSMS: true,
    SendNotifications: true,
    DisplayColor: "",
    IsAllReport: true,
    IsAllJobCardStatus: true,
    SessionTimeOut: 0,
    PrimaryRole: "",
    primaryRoleText: '',
    otherPrimaryRoleText: ''
  });

  const [inputErrors, setInputErrors] = useState<any>({});

  const handleInputChange = (e: any) => {
    const setter = {
      ...inputs,
      [e.name]: e.value
    }

    if (e.name === 'primaryRoleText') {
      if (e.value === 'Other') {
        setter.PrimaryRole = 'Other: ' + inputs.otherPrimaryRoleText
      } else {
        setter.PrimaryRole = e.value
      }
    }

    if (e.name === 'otherPrimaryRoleText') {
      setter.PrimaryRole = 'Other: ' + e.value
    }

    setInputs(setter);

    setFormIsDirty(true);
  }

  async function submitEmployee() {
    setSubmitting(true);

    let validationItems = [
      { key: 'FirstName', value: inputs.FirstName, required: true, type: Enums.ControlType.Text },
      { key: 'LastName', value: inputs.LastName, required: true, type: Enums.ControlType.Text },
      { key: 'EmailAddress', value: inputs.EmailAddress, required: true, type: Enums.ControlType.Email, rejectServCraft: true },
      { key: 'MobileNumber', value: inputs.MobileNumber, required: false, type: Enums.ControlType.ContactNumber },
      { key: 'PrimaryRole', value: inputs.PrimaryRole, required: true, type: Enums.ControlType.Text },
    ];

    if (inputs.canLogin === true) {
      validationItems.push({
        key: 'password', value: inputs.password, required: true, type: Enums.ControlType.Text
      });

      //   key: 'confirmPassword', value: inputs.confirmPassword, required: true, type: Enums.ControlType.Text, equalsPassword: inputs.password

      validationItems.push({
        key: 'SessionTimeOut', value: inputs.SessionTimeOut, required: true, type: Enums.ControlType.Number, lte: 10080, gte: 0
      });
    }


    let { isValid, errors } = Helper.validateInputs(validationItems);

    if (inputs.canLogin === true) {
      // Build a consistent set of user/company words for password strength checks
      const companyName = Storage?.getCookie ? Storage.getCookie(Enums.Cookie?.servCompanyName) : undefined;
      const userwords = [
        inputs.EmailAddress,
        `${(inputs.FirstName || '').trim()} ${(inputs.LastName || '').trim()}`.trim(),
        companyName,
      ]
        .filter(Boolean)
        // de-dupe while preserving order
        .filter((v: any, i: any, a: any) => a.indexOf(v) === i);

      const strengthError = Helper.getPasswordStrengthError(inputs.password, { userwords });
      if (strengthError) {
        isValid = false;
        (errors as any).password = strengthError;
      }
    }

    if (inputs.password.length > 100) {
      isValid = false;
      (errors as any).password = 'Please use a password of 100 characters or less';
    }

    if (inputs.primaryRoleText === 'Other' && !inputs.otherPrimaryRoleText.trim()) {
      errors["otherPrimaryRoleText"] = `Please specify the employee role`;
      isValid = false;
    }

    if (errors["SessionTimeOut"]) {
      errors["SessionTimeOut"] = "Must be less than or equal to 7 days";
    }

    if (inputs.canLogin === true && inputs.SessionTimeOut < Constants.minimumSessionTimeoutMinutes && inputs.SessionTimeOut > 0) {
      errors["SessionTimeOut"] = `Must be greater than ${Constants.minimumSessionTimeoutMinutes} minutes or leave as 0 for infinite`;
      isValid = false;
    }

    setInputErrors(errors);

    if (isValid) {

      let isAllReport = selectedPermissions && selectedPermissions.findIndex((x: any) => x === "Employee.IsAllReport") > -1;

      let employeeParams = {
        FirstName: inputs.FirstName,
        LastName: inputs.LastName,
        EmailAddress: inputs.EmailAddress,
        MobileNumber: inputs.MobileNumber,
        SendEmail: inputs.SendEmail,
        SendSMS: inputs.SendSMS,
        SendNotifications: inputs.SendNotifications,
        IsSalesRepresentative: inputs.IsSalesRepresentative,
        IsTechnician: inputs.IsTechnician,
        IsActive: true,
        DisplayColor: inputs.DisplayColor,
        IsAllReport: isAllReport,
        IsAllJobCardStatus: inputs.IsAllJobCardStatus,
        PrimaryRole: inputs.PrimaryRole,
      }
      let params = {
        Employee: employeeParams,
        PermissionList: selectedPermissions
      };

      //  == inputs.confirmPassword
      if (inputs.canLogin && !!inputs.password) {
        params = {
          ...params, User: {
            UserName: inputs.EmailAddress,
            IsActive: true,
            Password: inputs.password,
            SessionTimeOut: inputs.SessionTimeOut
          }
        };
      }

      const employeePostResponse = await Fetch.post({
        url: '/Employee',
        params: params
      });
      if (employeePostResponse.ID) {
        Helper.mixpanelTrack(Constants.mixPanelEvents.createEmployee, {
          "employeeID": employeePostResponse.ID
        });
        setFormIsDirty(false);
        await Helper.waitABit();
        toast.setToast!!!({
          message: 'Employee created successfully',
          show: true,
          type: 'success'
        });
        Helper.nextRouter(Router.push, `/settings/employee/${employeePostResponse.ID}?created=true`);
      } else if (employeePostResponse?.Message) {
        const msg = employeePostResponse.Message;
        if (/email/i.test(msg)) {
          // Server doesn't return a field name for this error - the message text always
          // references the email address, so that's used to route it to the field itself
          // rather than a generic toast.
          setInputErrors({ ...inputErrors, EmailAddress: msg });
          showNotification({ color: 'yellow.7', message: msg, autoClose: 5000 });
        } else {
          showNotification({ color: 'yellow.7', message: msg, autoClose: 5000 });
        }
        setSubmitting(false);
      } else if (employeePostResponse?.message || employeePostResponse?.serverMessage) {
        const msg = employeePostResponse.message || employeePostResponse.serverMessage;
        showNotification({ color: 'yellow.7', message: msg, autoClose: 4000 });
        setSubmitting(false);
      } else {
        showNotification({ color: 'yellow.7', message: 'Something went wrong', autoClose: 4000 });
        setSubmitting(false);
      }
    } else {
      toast.setToast!!!({
        message: 'There are errors on the page.',
        show: true,
        type: 'error'
      });
      setSubmitting(false);
    }

    return isValid;
  }

  const setColour = (colour: any) => {
    setInputs({ ...inputs, DisplayColor: colour });
    setFormIsDirty(true);
  }

  const understandMoreClicked = () => {
    setConfirmEmployeeAccessOptions({
      display: true,
      onConfirm: () => {
      },
    });
  };

  const handleCanLoginChange = (e: any) => {
    handleInputChange(e);

    // if (inputs.canLogin || isTrial) {
    // } else {
    //     display: true,
    //     onConfirm: () => {
    //     },
  };

  const cancel = () => {
    Helper.nextRouter(Router.push, '/settings/employee/list');
  };

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '/settings', suppressLink: true },
              { text: 'Employees', link: '/settings/employee/list' },
              { text: 'Create Employee', link: '/settings/employee/create' },
            ]}
          />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <div className="split">
            <div>
              <h3>Employee Details</h3>
              <div className="row">
                <div className="column">
                  <SCInput
                    onChange={handleInputChange}
                    error={inputErrors.EmailAddress}
                    label={"Email address (this will be the employee's username)"}
                    name="EmailAddress"
                    required={true}
                    value={inputs.EmailAddress}
                    cypress="data-cy-email"
                    placeholder="email@address.com"
                  />
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <SCInput
                    onChange={handleInputChange}
                    error={inputErrors.FirstName}
                    label={"First name"}
                    name="FirstName"
                    required={true}
                    value={inputs.FirstName}
                    cypress="data-cy-firstname"
                  />
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <SCInput
                    onChange={handleInputChange}
                    error={inputErrors.LastName}
                    label={"Last name"}
                    name="LastName"
                    required={true}
                    value={inputs.LastName}
                    cypress="data-cy-lastname"
                  />
                </div>
              </div>

              <div className="row">
                <div className="column">
                  <SCInput
                    onChange={handleInputChange}
                    error={inputErrors.MobileNumber}
                    label={"Mobile number"}
                    name="MobileNumber"
                    type="tel"
                    value={inputs.MobileNumber}
                    cypress="data-cy-mobile"
                  />
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <SCComboBox
                    canSearch={false}
                    onChange={(value: any) => handleInputChange({ name: 'primaryRoleText', value })}
                    error={inputErrors.PrimaryRole}
                    label={'Primary role'}
                    hint={`Specify the employee's primary role in the business`}
                    name="primaryRoleText"
                    required
                    options={primaryRoles}
                    value={inputs.primaryRoleText}
                  />
                </div>
              </div>
              {
                inputs.primaryRoleText === 'Other' &&
                <div className="row">
                  <div className="column">
                    <SCInput
                      onChange={handleInputChange}
                      error={inputErrors.otherPrimaryRoleText}
                      label={"Other Primary Role"}
                      name="otherPrimaryRoleText"
                      required
                      value={inputs.otherPrimaryRoleText}
                    />
                  </div>
                </div>
              }

              {(accessStatus !== Enums.AccessStatus.LockedWithOutAccess && accessStatus !== Enums.AccessStatus.LockedWithAccess)
                || (customerStatus === "Trial") ?
                <>
                  <div className="row">
                    <div className="column">
                      <Flex align={"center"} justify={"space-between"} mt={"1rem"}>
                        <div>
                          <Switch
                            style={{ display: "inline-block" }}
                            onLabel={"Login Access"}
                            offLabel={"Comms Only"}
                            size='xl'
                            checked={inputs.canLogin}
                            onChange={() => handleCanLoginChange({ name: 'canLogin', value: !inputs.canLogin })}
                          />
                          <MantineButton variant="subtle" onClick={understandMoreClicked}>Understand More</MantineButton>
                        </div>
                      </Flex>
                      {/* <SCCheckbox
                        onChange={() => handleCanLoginChange({ name: 'canLogin', value: !inputs.canLogin })}
                        value={inputs.canLogin}
                        label="Give employee login access?"
                        cypress="data-cy-canlogin"
                      /> */}
                    </div>
                  </div>
                </>
                : ''}

              {inputs.canLogin ? <>
                {/* <div className="row">
                  <div className="column">
                    <SCInput
                      label={"Username"}
                      value={inputs.EmailAddress}
                      readOnly={true}
                    />
                  </div>
                </div> */}
                <div className="row">
                  <div className="column">
                    <SCPasswordInput
                      onChange={handleInputChange}
                      error={inputErrors.password}
                      label={"Password"}
                      name="password"
                      required={true}
                      value={inputs.password}
                      userwords={[
                        inputs.EmailAddress,
                        `${(inputs.FirstName || '').trim()} ${(inputs.LastName || '').trim()}`.trim(),
                        (Storage?.getCookie ? Storage.getCookie(Enums.Cookie?.servCompanyName) : undefined)
                      ].filter(Boolean).filter((v: any, i: any, a: any) => a.indexOf(v) === i)}
                    />
                    <Text size="sm" c="dimmed" mt="xs">
                      Choose a strong password with at least 10 characters, including uppercase, lowercase, and a number. Skip common phrases like 'password', 'qwerty', '1234', or your name.
                    </Text>
                  </div>
                </div>
                {/* <div className="row">
                  <div className="column">
                    <SCInput
                      onChange={handleInputChange}
                      error={inputErrors.confirmPassword}
                      label={"Confirm password"}
                      name="confirmPassword"
                      required={true}
                      type={"password"}
                      value={inputs.confirmPassword}
                    />
                  </div>
                </div> */}

                {/* <MinuteSelector
                  label="Session Timeout"
                  hint="0 will never expire"
                  value={inputs.SessionTimeOut}
                  name="SessionTimeOut"
                  required={true}
                  error={inputErrors.SessionTimeOut}
                  onChange={(e) => handleInputChange({ name: "SessionTimeOut", value: parseFloat(e) })}
                  singleColumnView={true}
                /> */}
              </>
                : ''
              }

              {/* <h3>Communication</h3>
              <SCCheckbox
                onChange={() => handleInputChange({ name: 'SendEmail', value: !inputs.SendEmail })}
                value={inputs.SendEmail}
                label="Receive Email Notifications"
                cypress="data-cy-sendemail"
              />
              <SCCheckbox
                onChange={() => handleInputChange({ name: 'SendSMS', value: !inputs.SendSMS })}
                value={inputs.SendSMS}
                label="Receive SMS Notifications"
                cypress="data-cy-sendsms"
              />
              <SCCheckbox
                onChange={() => handleInputChange({ name: 'SendNotifications', value: !inputs.SendNotifications })}
                value={inputs.SendNotifications}
                label="Receive Push Notifications"
                cypress="data-cy-sendnotifications"
              /> */}

              {/* {inputs.canLogin ?
                <>
                  <h3>Permissions</h3>
                  <EditPermissions selectedPermissions={selectedPermissions} setSelectedPermissions={setSelectedPermissions} />
                </> : ''
              } */}

              {/* <h3>Colour</h3>

              <ColourPicker selectedColour={inputs.DisplayColor} setColour={setColour} /> */}

              <div className="actions">
                <MantineButton disabled={submitting} onClick={submitEmployee} ml={"0.5rem"} >
                  {submitting ? "Creating" : "Create"}
                </MantineButton>
                {/* <Button text={submitting ? "Creating" : "Create"} disabled={submitting} extraClasses="auto" onClick={submitEmployee} /> */}
                <MantineButton disabled={submitting} onClick={cancel} variant={"outline"}>
                  Cancel
                </MantineButton>
                {/* <Button text="Cancel" extraClasses="auto hollow" disabled={submitting} onClick={cancel} /> */}
              </div>

            </div>
            {/* <div className="empty">
              <img src="/customer-list.svg" alt="Job Folder" />
              <h3>Create new employee</h3>
              <p>Add new technicians or <br /> administrators quick and easy</p>
            </div> */}
          </div>
        </div>
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />
      <ConfirmAccess options={confirmEmployeeAccessOptions} setOptions={setConfirmEmployeeAccessOptions} module={Enums.Module.Employee} />

      <style jsx>{`
        .add-location {
          align-items: center;
          color: ${colors.bluePrimary};
          cursor: pointer;
          display: flex;
          font-weight: bold;
        }
        .add-location img {
          margin: 2px 0.5rem 0 0;
        }
        .container {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          height: 100%;
          padding: 1.5rem 3rem;
          overflow-x: hidden;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: ${layout.inputWidth};
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .title {
          align-items: center;
          color: ${colors.darkPrimary};
          display: flex;
          height: 2.5rem;
          width: 100%;
        }
        .title h1 {
          font-size: 32px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .row-align {
          align-items: center;
          height: 1.75rem
        }
        .empty {
          align-items: center;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          height: fit-content;
          justify-content: center;
          margin-left: 1.5rem;
          width: 520px;
        }
        .empty img {
          height: 110px;
          margin-bottom: 1rem;
        }
        .empty h3 {
          color: ${colors.darkSecondary};
          font-size: 16px;
          margin: 0 0 0.75rem;
        }
        .empty p {
          color: ${colors.blueGrey};
          margin: 0;
          text-align: center;
        }
        .actions {
            margin-top: 1rem;
            display: flex;
            flex-direction: row-reverse;
        }
        .actions :global(.button){
            margin-left: 0.5rem;
            margin-top: 1rem;
            padding: 0 1rem;
            white-space: nowrap;
        }
      `}</style>
    </div>
  );
}

export default CreateEmployee

export const Route = createFileRoute('/_authenticated/settings/employee/create')({ component: CreateEmployee })
